import React, {useEffect, useState} from 'react';
import {Card, Col, Row} from "react-bootstrap";
import CreateVOCContract from "./CreateVOCContract";
import {Link, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import CreateRadonTestReport from "./CreateRadonTestReport";

const OperationsForms = () => {

    const [vOCContracts, setVOCContracts] = useState()
    const [radonTestReport, setRadonTestReport] = useState()

    const {id} = useParams();
    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const loadVOCContracts = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/voc_contracts/`, {
            // const {data} = await axios.get(`http://127.0.0.1:8000/api/voc_contracts/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        })
        // console.log(data)
        setVOCContracts(data)
    }

    const loadRadonReports = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/radon_test_reports/`, {
        // const {data} = await axios.get(`http://127.0.0.1:8000/api/radon_test_reports/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        })
        // console.log(data)
        setRadonTestReport(data)
    }

    useEffect(()=>{
        loadVOCContracts()
        loadRadonReports()
    }, []);

    return(
        <div>
            <br />
            <h1>
                Radon Test Report & VOC Diagnostic & Mitigation Proposal / Contract
            </h1>
            <br /><br />
            <Row style={{textAlign: 'center'}}>
                <Col>
                    <Card>
                        <Card.Body>
                            <Card.Title>Radon Test Report</Card.Title>
                            <Card.Text>
                                Allows User to Create a Radon Test Report
                            </Card.Text>
                            <CreateRadonTestReport />
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card>
                        <Card.Body>
                            <Card.Title>VOC Diagnostic & Mitigation Proposal / Contract</Card.Title>
                            <Card.Text>
                                Allows User to Create a VOC Diagnostic & Mitigation Proposal / Contract
                            </Card.Text>
                            <CreateVOCContract />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col>
                    {
                        radonTestReport?.map(item =>
                        <Row
                        key={item.id}
                        style={{textAlign: 'center', padding: '15px 10px'}}
                        >
                            <Link
                                className={'btn btn-primary'}
                                to={`/radon_test_report/${item.id}/`}
                            >
                                Report For {item.client_name}
                            </Link>
                        </Row>
                        )
                    }
                </Col>
                <Col>
                    {
                        vOCContracts?.map(item =>
                            <Row
                                key={item.id}
                                style={{textAlign: 'center', padding: '15px 10px'}}
                            >
                                <Link
                                    className={'btn btn-info'}
                                    to={`/voc_contract/${item.id}/`}
                                >
                                    Contract {item.proposal_submitted_to_company}
                                </Link>
                            </Row>
                        )
                    }
                </Col>
            </Row>
        </div>
    )
};

export default OperationsForms;